import { Vorversicherer } from '../data/vorversicherung';
import {
  StatePreV16,
  StateV16,
  VorversicherungenPreV16,
} from './16_migrate_vorversicherung.interface';

export const migrateVorversicherung = (
  previousState: StatePreV16,
  newVersion: number,
): StateV16 => {
  const versicherungData: Array<Vorversicherer> = previousState.versicherungData;
  const migratedVorversicherungen: Array<VorversicherungenPreV16> = previousState.vorversicherungen;

  migratedVorversicherungen.forEach(vorversicherung =>
    vorversicherung.vorversicherungsListe.filter(vorversicherungsItem => {
      const isVersicherungsgesellschaftInVersicherungData = versicherungData.some(
        versicherungDataItem => {
          return versicherungDataItem.value === vorversicherungsItem.versicherungsgesellschaft;
        },
      );
      if (!isVersicherungsgesellschaftInVersicherungData) {
        vorversicherungsItem.versicherungsgesellschaft = null;
      }
      return vorversicherungsItem.versicherungsgesellschaft;
    }),
  );
  return {
    ...previousState,
    version: newVersion,
    vorversicherungen: migratedVorversicherungen,
  };
};
